module.exports = __webpack_public_path__ + "static/web-painting-4-f6e34292f2950cb71eb5177c1bd2bb34.jpg";